// src/pages/NotFound/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button/Button.jsx';

export const NotFound = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '40px',
      textAlign: 'center',
    }}>
      <h1 style={{
        fontSize: '72px',
        fontWeight: 700,
        color: 'rgb(var(--c-accent))',
        marginBottom: '16px',
      }}>
        404
      </h1>
      <h2 style={{
        fontSize: '24px',
        fontWeight: 600,
        color: 'rgb(var(--c-text))',
        marginBottom: '12px',
      }}>
        Страница не найдена
      </h2>
      <p style={{
        fontSize: '16px',
        color: 'rgb(var(--c-text-secondary))',
        marginBottom: '24px',
      }}>
        Извините, запрошенная страница не существует или была перемещена.
      </p>
      <Link to="/">
        <Button>Вернуться на главную</Button>
      </Link>
    </div>
  );
};